/* ============================================================
   ÉPRIS Wishlist Page — Full-View Rendering
   ============================================================
   Läuft NUR auf [data-wishlist-page] (Wishlist Page Template).
   Render-Pattern wie Drawer aber mit größeren Cards + ATC-Button +
   subtle reveal-Animation (epris-card-reveal class).
   ============================================================ */

(function() {
  'use strict';

  // Bundle-Varianten brauchen vor dem Cart-Add eine Duft-Auswahl auf der PDP.
  // Sync mit assets/epris-bundle.js + snippets/progress-bar.liquid + epris-wishlist-drawer.js
  const BUNDLE_VARIANT_IDS = [
    47618191556951,  // 2er-Bundle
    51676082504023,  // 5er-Bundle
    48939107975511,  // 3er-Bundle
    52122126647639,  // 3er-Bundle
    52272604545367,  // 3er-Bundle
  ];
  function isBundle(variantId) {
    return BUNDLE_VARIANT_IDS.includes(parseInt(variantId, 10));
  }

  function moneyFormat(cents) {
    cents = parseInt(cents, 10) || 0;
    cents = Math.max(0, cents);
    const fmt = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) || '€{{amount_with_comma_separator}}';
    const m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    const ph = m ? m[1] : 'amount';
    const n = cents / 100;
    let s;
    switch (ph) {
      case 'amount_no_decimals':
        s = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        break;
      case 'amount_with_comma_separator':
        s = n.toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+,)/g, '$1.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        s = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        break;
      case 'amount_with_space_separator':
        s = n.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1 ');
        break;
      case 'amount_with_apostrophe_separator':
        s = n.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1'");
        break;
      case 'amount_no_decimals_with_space_separator':
        s = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        break;
      default:
        s = n.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, s);
  }

  function escapeHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function ready() {
    if (!window.eprisWishlist) {
      if ((ready._retries = (ready._retries || 0) + 1) > 20) return;
      return setTimeout(ready, 100);
    }
    init();
  }

  function init() {
    const page = document.querySelector('[data-wishlist-page]');
    if (!page) return;

    const grid = page.querySelector('[data-wishlist-list]');
    const empty = page.querySelector('[data-wishlist-empty]');
    const footer = page.querySelector('[data-wp-footer]');
    const clearBtn = page.querySelector('[data-wp-clear]');

    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        if (window.eprisWishlist.count() === 0) return;
        const msg = (window.EPRIS_TRANS && window.EPRIS_TRANS.wishlistClearConfirm)
          || 'Alle Düfte aus der Wishlist entfernen?';
        if (confirm(msg)) {
          window.eprisWishlist.clear();
        }
      });
    }

    /* Bulk-ATC auf Page: alle Items via single fetch zum Cart, bleiben in Wishlist */
    const addAllBtn = page.querySelector('[data-wp-add-all]');
    /* MutationObserver wartet bis cart-drawer wirklich neu rendered */
    function waitForCartDrawerUpdate(el, timeoutMs) {
      return new Promise(resolve => {
        if (!el) return resolve();
        let done = false;
        function finish() {
          if (done) return;
          done = true;
          mo.disconnect();
          clearTimeout(failsafe);
          requestAnimationFrame(() => requestAnimationFrame(resolve));
        }
        const mo = new MutationObserver(() => finish());
        mo.observe(el, { childList: true });
        const failsafe = setTimeout(finish, timeoutMs || 2000);
      });
    }

    if (addAllBtn) {
      addAllBtn.addEventListener('click', async () => {
        const allItems = window.eprisWishlist.getAll();
        if (allItems.length === 0 || addAllBtn.disabled) return;
        const items = allItems.filter(i => i.available !== false);
        if (items.length === 0) return;
        addAllBtn.disabled = true;

        if (window.eprisLoader) window.eprisLoader.show({ withLoader: true });

        try {
          const payload = items.map(i => ({ id: parseInt(i.variant_id, 10), quantity: 1 })).filter(x => !isNaN(x.id));
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: payload })
          });
          if (!res.ok) throw new Error('add failed');

          const cartDrawerEl = document.querySelector('cart-drawer');

          /* cart:refresh → theme refresh OHNE auto-show */
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.body.dispatchEvent(new CustomEvent('cart:product-added', { bubbles: true }));

          /* Wait bis items wirklich im DOM sind */
          await waitForCartDrawerUpdate(cartDrawerEl, 2500);

          /* JETZT show */
          if (cartDrawerEl && typeof cartDrawerEl.show === 'function') {
            cartDrawerEl.show();
          }

          await new Promise(r => setTimeout(r, 380));

          if (window.eprisLoader) window.eprisLoader.hide();
          addAllBtn.disabled = false;
        } catch (err) {
          console.error('[wishlist-page add-all]', err);
          if (window.eprisLoader) window.eprisLoader.hide();
          addAllBtn.disabled = false;
        }
      });
    }

    grid.addEventListener('click', onGridClick);

    /* Surgical update statt full innerHTML-Replace (verhindert Bilderflicker) */
    window.eprisWishlist.onChange((items, action, variantId) => {
      surgicalRender(items, action, variantId);
    });
    render();

    function surgicalRender(items, action, variantId) {
      if (!action || action === 'init' || action === 'sync' || action === 'clear' || items.length === 0) {
        render();
        return;
      }
      const cssEscapedId = (window.CSS && CSS.escape) ? CSS.escape(String(variantId)) : String(variantId).replace(/"/g, '\\"');

      if (action === 'add') {
        grid.hidden = false;
        empty.hidden = true;
        footer.hidden = false;
        const item = items.find(i => String(i.variant_id) === String(variantId));
        if (!item) return;
        const tmp = document.createElement('div');
        tmp.innerHTML = itemHtml(item, 0);
        const newCard = tmp.firstElementChild;
        if (newCard) {
          newCard.style.setProperty('--epris-reveal-delay', '0ms');
          grid.insertBefore(newCard, grid.firstChild);
          requestAnimationFrame(() => newCard.classList.add('is-visible'));
        }
        return;
      }
      if (action === 'remove') {
        const card = grid.querySelector(`[data-variant-id="${cssEscapedId}"]`);
        if (card) {
          card.classList.add('is-removing');
          setTimeout(() => card.remove(), 300);
        }
        if (items.length === 0) {
          setTimeout(() => {
            grid.innerHTML = '';
            grid.hidden = true;
            empty.hidden = false;
            footer.hidden = true;
          }, 310);
        }
        return;
      }
      if (action === 'update') {
        // Surgische Field-Updates statt LI-Replace → <img>-Element bleibt erhalten
        const item = items.find(i => String(i.variant_id) === String(variantId));
        const oldCard = grid.querySelector(`[data-variant-id="${cssEscapedId}"]`);
        if (!item || !oldCard) return;

        const img = oldCard.querySelector('img.epris-wp-item__img');
        if (img && item.image && img.getAttribute('src') !== item.image) {
          img.setAttribute('src', item.image);
        }
        const titleEl = oldCard.querySelector('.epris-wp-item__title');
        if (titleEl && item.title && titleEl.textContent !== item.title) {
          titleEl.textContent = item.title;
        }
        const priceEl = oldCard.querySelector('.epris-wp-item__price-current');
        if (priceEl && item.price) {
          const newPrice = moneyFormat(item.price);
          if (priceEl.textContent !== newPrice) priceEl.textContent = newPrice;
        }
        // Available-State change → full replace für sold-out-Badge / Notify-Btn
        const wasAvailable = oldCard.dataset.available === 'true';
        const isAvailable = item.available !== false;
        if (wasAvailable !== isAvailable) {
          const tmp = document.createElement('div');
          tmp.innerHTML = itemHtml(item, 0);
          const newCard = tmp.firstElementChild;
          if (newCard) {
            newCard.classList.add('is-visible');
            oldCard.replaceWith(newCard);
          }
        }
        return;
      }
      render();
    }

    function render() {
      const items = window.eprisWishlist.getAll();
      if (items.length === 0) {
        grid.innerHTML = '';
        grid.hidden = true;
        empty.hidden = false;
        footer.hidden = true;
        return;
      }
      grid.hidden = false;
      empty.hidden = true;
      footer.hidden = false;
      grid.innerHTML = items.map((item, idx) => itemHtml(item, idx)).join('');

      /* Stagger reveal — nutze theme's CSS animation pattern */
      grid.querySelectorAll('.epris-wp-item').forEach((el, idx) => {
        el.style.setProperty('--epris-reveal-delay', (idx * 60) + 'ms');
        requestAnimationFrame(() => el.classList.add('is-visible'));
      });
    }

    function itemHtml(item, idx) {
      const vid = escapeHtml(item.variant_id);
      const title = item.title || 'Produkt';
      const url = item.url || (item.handle ? '/products/' + item.handle : '#');
      const image = item.image || '';
      const price = item.price ? moneyFormat(item.price) : '';
      const compare = item.compare_at_price ? moneyFormat(item.compare_at_price) : '';
      const vendor = item.vendor || '';
      const showCompare = compare && parseInt(item.compare_at_price, 10) > parseInt(item.price, 10);
      const isAvailable = item.available !== false;
      const T = window.EPRIS_TRANS || {};

      const imageHtml = image
        ? `<img src="${escapeHtml(image)}" alt="" loading="lazy" decoding="async" class="epris-wp-item__img">`
        : '<div class="epris-wp-item__img epris-wp-item__img--placeholder"></div>';

      const compareHtml = showCompare
        ? `<span class="epris-wp-item__price-compare">${escapeHtml(compare)}</span>`
        : '';

      const soldOutBadge = !isAvailable
        ? `<span class="epris-wp-item__stock-badge">${escapeHtml(T.wishlistSoldOut || 'Ausverkauft')}</span>`
        : '';

      // Bundle-Produkte brauchen Duft-Auswahl auf PDP — Button wird zum Link statt zum ATC
      const ctaButton = !isAvailable
        ? `<button type="button" class="epris-wp-item__notify" data-wp-notify data-variant-id="${vid}">
             ${escapeHtml(T.wishlistNotifyMe || 'Benachrichtigen')}
           </button>`
        : isBundle(item.variant_id)
          ? `<a href="${escapeHtml(url)}" class="epris-wp-item__atc epris-wp-item__atc--configure" data-wp-configure>
               ${escapeHtml(T.wishlistBundleConfigure || 'Düfte wählen')} →
             </a>`
          : `<button type="button" class="epris-wp-item__atc" data-wp-atc data-variant-id="${vid}">
               ${escapeHtml(T.wishlistAddToCart || 'In den Warenkorb')}
             </button>`;

      return `
        <article class="epris-wp-item epris-card-reveal ${isAvailable ? '' : 'is-unavailable'}"
          data-variant-id="${vid}" data-available="${isAvailable}">
          <a href="${escapeHtml(url)}" class="epris-wp-item__link">
            <div class="epris-wp-item__media">
              ${imageHtml}
              ${soldOutBadge}
              <button type="button" class="epris-wp-item__remove" data-wp-remove
                aria-label="Entfernen">
                <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
                  <path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
                </svg>
              </button>
            </div>
            <div class="epris-wp-item__info">
              ${vendor ? `<p class="epris-wp-item__vendor">${escapeHtml(vendor)}</p>` : ''}
              <h3 class="epris-wp-item__title">${escapeHtml(title)}</h3>
              <p class="epris-wp-item__price">
                ${compareHtml}
                <span class="epris-wp-item__price-current">${escapeHtml(price)}</span>
              </p>
            </div>
          </a>
          ${ctaButton}
        </article>
      `;
    }

    function onGridClick(e) {
      const removeBtn = e.target.closest('[data-wp-remove]');
      if (removeBtn) {
        e.preventDefault();
        e.stopPropagation();
        const card = removeBtn.closest('.epris-wp-item');
        if (!card) return;
        const vid = card.dataset.variantId;
        if (!vid) return;
        card.classList.add('is-removing');
        setTimeout(() => window.eprisWishlist.remove(vid), 300);
        return;
      }

      const atcBtn = e.target.closest('[data-wp-atc]');
      if (atcBtn) {
        e.preventDefault();
        e.stopPropagation();
        const vid = atcBtn.dataset.variantId;
        if (!vid || atcBtn.disabled) return;
        addToCart(atcBtn, vid);
        return;
      }

      const notifyBtn = e.target.closest('[data-wp-notify]');
      if (notifyBtn) {
        e.preventDefault();
        e.stopPropagation();
        const vid = notifyBtn.dataset.variantId;
        const item = window.eprisWishlist.getAll().find(i => i.variant_id === vid);
        if (!item) return;
        document.dispatchEvent(new CustomEvent('epris:notify:open', {
          detail: { product: { variant_id: vid, title: item.title, handle: item.handle, url: item.url } }
        }));
      }
    }

    async function addToCart(btn, variantId) {
      // Defensive: Bundles dürfen niemals ohne Konfiguration in den Cart
      // (CTA wird normalerweise zum Link gerendert, dieser Pfad ist Backup)
      if (isBundle(variantId)) {
        const item = window.eprisWishlist.getAll().find(i => String(i.variant_id) === String(variantId));
        const url = item && (item.url || (item.handle ? '/products/' + item.handle : null));
        if (url) window.location.href = url;
        return;
      }
      const originalText = btn.textContent;
      btn.disabled = true;
      btn.classList.add('is-loading');
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: 'cart-drawer' })
        });
        if (!res.ok) throw new Error('add failed');
        const addData = await res.json();
        const cartData = await (await fetch('/cart.js')).json();
        if (addData.sections) cartData.sections = addData.sections;

        btn.classList.remove('is-loading');
        btn.classList.add('is-success');
        btn.textContent = (window.EPRIS_TRANS && window.EPRIS_TRANS.wishlistAdded) || 'Hinzugefügt';

        /* cart:change mit baseEvent variant:add → cart-drawer öffnet sich */
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'variant:add', cart: cartData }
        }));
        document.body.dispatchEvent(new CustomEvent('cart:product-added', { bubbles: true }));
        const cartDrawerEl = document.querySelector('cart-drawer');
        if (cartDrawerEl && typeof cartDrawerEl.show === 'function') {
          cartDrawerEl.show();
        }

        setTimeout(() => {
          btn.classList.remove('is-success');
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      } catch (err) {
        console.error('[wishlist-page atc]', err);
        btn.classList.remove('is-loading');
        btn.disabled = false;
        btn.textContent = originalText;
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
